"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = require("react");
var hls_js_1 = __importDefault(require("hls.js"));
var usePreloadHls = function (_a) {
    var _b;
    var sources2 = _a.sources2, videoRef2 = _a.videoRef2, isSecondVideo = _a.isSecondVideo, setPlayingSecondVideo = _a.setPlayingSecondVideo, setIsSecondVideoLoading = _a.setIsSecondVideoLoading;
    var _c = react_1.useState(null), hlsInstance = _c[0], setHlsInstance = _c[1];
    var muxUrl = 'https://stream.mux.com/';
    react_1.useEffect(function () {
        var video = videoRef2.current;
        if (!video)
            return;
        if (!(sources2 === null || sources2 === void 0 ? void 0 : sources2.length))
            return;
        var mp4Source = sources2.find(function (src) { return src.type === 'video/mp4' && src.src.includes(muxUrl); });
        var source = mp4Source !== null && mp4Source !== void 0 ? mp4Source : sources2.find(function (src) { return src.type === 'application/x-mpegURL'; });
        if (!source) {
            for (var _i = 0, sources2_1 = sources2; _i < sources2_1.length; _i++) {
                var _a = sources2_1[_i], type = _a.type, src = _a.src;
                if (video.canPlayType(type)) {
                    video.src = src;
                    return;
                }
            }
            console.error('Your browser does not support any video source provided 🤕');
            return;
        }
        video.onloadedmetadata = function () {
            setIsSecondVideoLoading === null || setIsSecondVideoLoading === void 0 ? void 0 : setIsSecondVideoLoading(false);
            setPlayingSecondVideo === null || setPlayingSecondVideo === void 0 ? void 0 : setPlayingSecondVideo(!!isSecondVideo);
            if (isSecondVideo) {
                video.play();
            }
        };
        if (video.canPlayType(source.type)) {
            video.src = source.src;
        }
        else if (hls_js_1.default.isSupported()) {
            var hls_1 = new hls_js_1.default({
                startLevel: 3,
                maxStarvationDelay: 3,
                maxLoadingDelay: 3,
            });
            setHlsInstance(hls_1);
            hls_1.on(hls_js_1.default.Events.LEVEL_LOADED, function () {
                var level3BANDWITH = hls_1.levels[3].bitrate;
                hls_1.config.abrEwmaDefaultEstimate = level3BANDWITH * 1.2;
            });
            hls_1.attachMedia(video);
            hls_1.on(hls_js_1.default.Events.MEDIA_ATTACHED, function () {
                hls_1.loadSource(source.src);
                hls_1.config.testBandwidth = false;
            });
            hls_1.on(hls_js_1.default.Events.MANIFEST_LOADED, function () {
                setPlayingSecondVideo === null || setPlayingSecondVideo === void 0 ? void 0 : setPlayingSecondVideo(!!isSecondVideo);
            });
        }
        else {
            console.error('This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API');
        }
        return function () {
            if (hlsInstance)
                hlsInstance.destroy();
            setHlsInstance(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_b = sources2 === null || sources2 === void 0 ? void 0 : sources2[0]) === null || _b === void 0 ? void 0 : _b.src, videoRef2]);
    return hlsInstance;
};
exports.default = usePreloadHls;
